import { Box, Modal } from "@mui/material";
import React, { useState } from "react";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import { ModalStyle } from "../../../../common/components/modalstyle/ModalStyle";
import CSSDKit from "./CSSDKit";
import CSSDMachine from "./CSSDMachine";

const goalTypeOptions = [
  { id: 1, label: "Machine-wise" },
  { id: 2, label: "Kit-wise" },
];

function CSSDTATDetails(props) {
  const { openCSSDCycleDetailsModal, setOpenCSSDCycleDetailsModal } = props;
  const [selectedTab, setSelectedTab] = useState("Machine-wise");

  return (
    <Modal open={openCSSDCycleDetailsModal}>
      <Box sx={ModalStyle} className="w-[95%] h-[90%] space-y-2">
        <div className="flex justify-between">
          <label className="font-semibold">CSSD Cycle Details</label>
          <button
            type="button"
            onClick={() => {
              setOpenCSSDCycleDetailsModal(false);
            }}
          >
            <CloseModalIcon />
          </button>
        </div>
        <div className="flex justify-start gap-3 whitespace-nowrap my-2">
          {goalTypeOptions.map(({ label }) => (
            <div
              key={label}
              onClick={() => setSelectedTab(label)}
              className={`flex items-center justify-center py-1 w-36 font-semibold cursor-pointer border rounded-md md:text-[12px] lg:text-[14px] transition-all duration-200
                ${selectedTab === label
                  ? "bg-customBlue text-white"
                  : "bg-[#EAE9FF] text-[#7E78D4] border-[#7E78D4]"
                }`}
            >
              {label}
            </div>
          ))}
        </div>
        {/* Conditional Rendering Based on Selected Label */}
        {selectedTab === "Machine-wise" && <CSSDMachine />}
        {selectedTab === "Kit-wise" && <CSSDKit />}
      </Box>
    </Modal>
  );
}

export default CSSDTATDetails;